/**
 * Pestañas móviles + acordeón desktop para la sección de información del producto (PDP).
 */
(function () {
  function initTabs(root) {
    if (!root || root.dataset.tabsInit === 'true') return;
    root.dataset.tabsInit = 'true';

    var tabs = root.querySelectorAll('[data-ch-product-tab]');
    var panels = root.querySelectorAll('[data-ch-product-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach(function (btn) {
        var isActive = btn.getAttribute('data-ch-product-tab') === id;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.classList.toggle('is-active', isActive);
      });
      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-ch-product-panel') === id;
        panel.hidden = !match;
        panel.classList.toggle('is-active', match);
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-ch-product-tab'));
      });
    });

    var first = root.querySelector('[data-ch-product-tab].is-active') || tabs[0];
    if (first) activate(first.getAttribute('data-ch-product-tab'));
  }

  function initDesktopAccordion(root) {
    if (!root || root.dataset.desktopAccordionInit === 'true') return;
    root.dataset.desktopAccordionInit = 'true';

    var cards = root.querySelectorAll('.ch-product-info__desktop .ch-product-info__card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var head = card.querySelector('.ch-product-info__card-head');
      if (!head) return;

      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', card.classList.contains('is-open') ? 'true' : 'false');

      function toggleCard() {
        var isOpen = card.classList.contains('is-open');

        // cerrar todos
        cards.forEach(function (c) {
          c.classList.remove('is-open');
          var h = c.querySelector('.ch-product-info__card-head');
          if (h) h.setAttribute('aria-expanded', 'false');
        });

        // si estaba cerrado, abrirlo
        if (!isOpen) {
          card.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
        }
      }

      head.addEventListener('click', toggleCard);
      head.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          toggleCard();
        }
      });
    });
  }

  document.querySelectorAll('.ch-product-info-table-section').forEach(function (root) {
    initTabs(root);
    initDesktopAccordion(root);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('.ch-product-info-table-section');
    if (root) {
      initTabs(root);
      initDesktopAccordion(root);
    }
  });
})();
